var map = {
	"./map-area-left.svg": 67073,
	"./map-area-right.svg": 91596,
	"./posi-blue.svg": 90019,
	"./posi-red.svg": 47224,
	"./react-buttom.svg": 48020,
	"./react-center.svg": 92056,
	"./react-left.svg": 70900,
	"./react-right.svg": 60699,
	"./row-map-left.svg": 75192,
	"./row-map-right.svg": 59239,
	"./row-top.svg": 3085
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 72922;